/**
 * Services Overview Component - Brutalist Streetwear Edition
 *
 * 3-column grid with brutalist cards, geometric icons, and lift effects.
 * Bold typography and heavy borders for maximum impact.
 */

import { Button } from '../Button';
import { Card } from '../Card';

interface Service {
  icon: string;
  title: string;
  description: string;
  ctaText: string;
  ctaLink: string;
}

interface ServicesOverviewProps {
  services: Service[];
}

export const ServicesOverview: React.FC<ServicesOverviewProps> = ({ services }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {services.map((service, index) => (
        <div
          key={index}
          data-aos="fade-up"
          data-aos-delay={index * 100}
          data-aos-duration="600"
        >
          <Card variant="brutalist" className="text-center h-full flex flex-col">
            {/* LARGE ICON with rotate/scale hover */}
            <div className="flex justify-center mb-6">
              <span className="text-6xl transition-transform duration-300 hover:scale-110 hover:rotate-3 inline-block">
                {service.icon}
              </span>
            </div>

            {/* TITLE: Brutalist heading style */}
            <h3 className="font-display text-2xl md:text-3xl font-bold uppercase tracking-wide mb-4">
              {service.title}
            </h3>

            {/* DESCRIPTION: Montserrat body text */}
            <p className="font-sans text-base leading-relaxed text-gray-700 mb-6 flex-grow">
              {service.description}
            </p>

            {/* CTA BUTTON: Brutalist style */}
            <Button
              variant="secondary"
              size="md"
              onClick={() => window.location.href = service.ctaLink}
            >
              {service.ctaText}
            </Button>
          </Card>
        </div>
      ))}
    </div>
  );
};
